
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IAutomationAppComponent, IAutomationObject } from "../../types";
import { IoMdFlash } from "react-icons/io";
import {  schema as schemaCounter } from '../../Devices/Counter/types'
import {  schema as schemaVirtualCounter } from '../../Devices/VirtualCounter/types'
import InsightsPanel from "./InsightsPanel";



export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IoMdFlash,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: InsightsPanel,
    createConfig:  {
        group: "Energy",
        name: "for a single building",
        description: "Energy overview",
        panel: OverviewPanel,
        defaultState: {  squereMeter: 1000/*, co2Current: 0.280, co2Heat: 0.311, co2Cold: 0.401, co2Gas:2.720, so2Fuel: 3140, so2Water: 0.6, actCostsCurrent: 0.3216, actCostsHeat: 0.09, actCostsCold: 0.17, actCostsGas: 0.6, actCostsFuel: 1980, actCostsWater: 2.28*/},
        defaultProperties: [
            //{ key: 'SquereMeter', value: '0' },

        ]
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaCounter || app.schema === schemaVirtualCounter
}